export enum ColorType {
  DEFAULT = 'default',
  PRIMARY = 'primary',
  ACCENT = 'accent',
  WARN = 'warn',
}
